// extracted by mini-css-extract-plugin
export var centerText = "_e9-8";
export var container = "_e9-0";
export var doughnutContainer = "_e9-7";
export var legend = "_e9-a";
export var legendItemColorDisplay = "_e9-b";
export var legendItemLabel = "_e9-d";
export var legendItemValue = "_e9-c";
export var lg = "_e9-5";
export var maxWidth = "_e9-9";
export var md = "_e9-4";
export var responsive = "_e9-6";
export var sm = "_e9-3";
export var xs = "_e9-2";
export var xxs = "_e9-1";